import api from "../lib/api";

/**
 * Operational Base API — small, focused surface for the shell.
 *
 * Every call goes through the shared `api` instance (auth + 30s timeout).
 * Endpoints are bound to the `operational_base` module on the backend
 * (L1 — registry-or-nothing); a hidden module returns 404 (L4).
 */
export const obApi = {
    capabilityMap: () => api.get("/operational-base/capability-map"),
    modules: () => api.get("/operational-base/modules"),
    activityPulse: (limit = 8) =>
        api.get(`/operational-base/activity-pulse?limit=${limit}`),
};
